/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskCategory
 */
export interface RiskCategory {
  /**
   *
   * @type {number}
   * @memberof RiskCategory
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof RiskCategory
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RiskCategory
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof RiskCategory
   */
  parent?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskCategory
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof RiskCategory
   */
  readonly children: string;
}

/**
 * Check if a given object implements the RiskCategory interface.
 */
export function instanceOfRiskCategory(value: object): value is RiskCategory {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  if (!('children' in value) || value['children'] === undefined) return false;
  return true;
}

export function RiskCategoryFromJSON(json: any): RiskCategory {
  return RiskCategoryFromJSONTyped(json, false);
}

export function RiskCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskCategory {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    title: json['title'],
    parent: json['parent'] == null ? undefined : json['parent'],
    description: json['description'] == null ? undefined : json['description'],
    children: json['children'],
  };
}

export function RiskCategoryToJSON(value?: Omit<RiskCategory, 'id' | 'children'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    title: value['title'],
    parent: value['parent'],
    description: value['description'],
  };
}
